import { render, staticRenderFns } from "./MediaGridWithBanner.vue?vue&type=template&id=31733a6a&"
import script from "./MediaGridWithBanner.vue?vue&type=script&lang=js&"
export * from "./MediaGridWithBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports